import { useEffect, useRef, useState } from "react";
import Modal from "../../components/Modal";
import Tabs from "../Tabs";
import styles from "../DetailsPage/MoreInfoHistoryPopUp/moreInfo.module.css";
import PropTypes from "prop-types";
import Unsubscribe from "./Unsubscribe";
import IntegrationConfig from "./IntegrationConfig";
import { DepentancyLogic } from "./DepentancyLogic";

const ConfigDetailsPopUp = ({
  isProfileHistoryOpen,
  setIsProfileHistoryOpen,
  setSelectedData,
  configData,
}) => {
  const scrollRef = useRef();
  const [scrollYPosition, setScrollYPosition] = useState(0);
  const [isScroll, setIsScroll] = useState(false);
  const handleModalOpen = (status) => {
    setSelectedData();
    setIsProfileHistoryOpen(status);
    setIsScroll(false);
  };
  const items = [
    {
      key: "dependency-logic",
      label: "Dependency Logic",
      children: (
        <DepentancyLogic
          configData={configData}
        />
      ),
    },
    {
      key: "integration",
      label: "Integration",
      children: <IntegrationConfig ConfigInfoData={configData} />,
    },
    {
      key: "unsubscribe",
      label: "Unsubscribe",
      children: <Unsubscribe configInfoData={configData} />,
    }
  ];
  const handleScroll = () => {
    if (scrollRef.current) {
      setScrollYPosition(scrollRef.current.scrollTop);
    }
  };
  useEffect(() => {
    if (isProfileHistoryOpen) {
      const element = scrollRef.current;
      if (element) {
        element.addEventListener("scroll", handleScroll);
        if (scrollYPosition > 8) {
          setIsScroll(true);
        } else setIsScroll(false);
      }
      return () => {
        if (element) {
          element.removeEventListener("scroll", handleScroll);
        }
      };
    }
  }, [scrollYPosition, isProfileHistoryOpen]);

  return (
    <Modal
      title="Purpose Configuration"
      open={isProfileHistoryOpen}
      setOpen={handleModalOpen}
      okText=""
      canelText=""
      type="profile-history"
      noActions={true}
      tabs={true}
      ref={scrollRef}
      bodyStyle={styles["modal-body"]}
    >
      <Tabs
        items={items}
        containerStyles={styles["tabs-container"]}
        buttonsStyles={styles["tabs-buttons"]}
        buttonStyle={styles["tab-button"]}
        activeButtonStyle={styles["active"]}
        contentStyles={styles["tabs-content"]}
        isScroll={isScroll}
      />
    </Modal>
  );
};

export default ConfigDetailsPopUp;

ConfigDetailsPopUp.propTypes = {
  isProfileHistoryOpen: PropTypes.bool,
  setIsProfileHistoryOpen: PropTypes.func,
  setSelectedData: PropTypes.func,
  configData: PropTypes.object,
};

ConfigDetailsPopUp.defaultProps = {
  isProfileHistoryOpen: false,
  setIsProfileHistoryOpen: () => {},
  setSelectedData: () => {},
  configData: null,
};
